import { render, staticRenderFns } from "./dj-form-cell.vue?vue&type=template&id=2fe522dc&scoped=true&"
import script from "./dj-form-cell.vue?vue&type=script&lang=js&"
export * from "./dj-form-cell.vue?vue&type=script&lang=js&"
import style0 from "./dj-form-cell.vue?vue&type=style&index=0&id=2fe522dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe522dc",
  null
  
)

export default component.exports